export const skills_zh = ['清潔常規', '首次清潔', '滅蟲常規', '首次滅蟲', '焗霧', '噴灑', '霧化消毒', '家居', '床蝨', '白蟻', '全效清潔', '油箱', '廚房', '甲醛'];

export const group_zh = ['首次', '常規', '夜間', '油箱', '廚房', 'STI'];

export const staff_fields = ['ID', 'profit', 'reach_profit'];
